import { Card, Col, Image, Row } from "react-bootstrap"
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri"
import ReactPaginate from "react-paginate"
import Stars from "./Stars"
import userDefault from '../img/userdefault.png'
import { withTranslation } from "react-i18next"
import ItemsHourExternal from "./ItemsHourExternal"
import { useEffect } from "react"

function  ItemsDoctors({t, items, handlePageClick,indexOfFirstPost,indexOfLastPost,pageCount,onClickShowCitaPatient,auth,
    publico, account, onClickSelectedSchedule, company, currentPage,linkAllianz, isSort, setIsSort, ordering, 
    startChecking, setStartChecking,checkIndex,setCheckIndex, setBasicItems,basicItems, doctorRef, countDr, setCountDr}) {
    

    useEffect(()=>{
        //console.log(it)
        //if(linkAllianz){
            let aux = [...startChecking]
            let findIndex = aux.findIndex(el=>el===checkIndex)
            if(findIndex >= 0){
                aux.splice(findIndex,1)
            }       
            setStartChecking(aux)
            //console.log(aux.length)
            if(aux.length === 0 && !isSort){
                //console.log('entro a ordenar')
                ordering()
            }
        //}
    }, [checkIndex])

    useEffect(()=>{
        //if(linkAllianz && countDr === 0) ordering()
        //console.log(countDr)
        if(countDr === 0) ordering()
    },[countDr])

    return (
        <>
            <Row className="mt-5">
                {
                    //items.slice(indexOfFirstPost, indexOfLastPost)
                    items.slice(indexOfFirstPost, indexOfLastPost).map((item, i)=>(
                        <Col xs="12" md="12" className="mb-3" key={i}>
                            <Card>
                                <Card.Body>
                                    <Row>
                                        <Col xs="12" md="6" className="border-card-1">
                                            <Row className="align-items-center">
                                                <Col xs="12" md="4">
                                                    <Image src={item.doctor.image ? item.doctor.image.url : userDefault} fluid className="img-card-citas img-card-doctors"/>
                                                </Col>
                                                <Col xs="12" md="8">
                                                    <h4 className="mb-1 text-dark-50 font-weight-bold">{`${item.doctor.name} ${item.doctor.lastName}`}</h4>
                                                    <label className="mb-0 d-block text-dark-50 font-weight-light font-size-16rem">{item.especialty.name}</label>
                                                    <small className="text-secondary d-block"><strong>{t('formacion')}: </strong>{item.formation ? item.formation : '-'}</small>                                                    
                                                    <Stars stars={item.doctor.rating} />
                                                </Col>
                                            </Row>
                                            <Row className="mt-3">
                                                <Col>
                                                    <p className="text-dark-50 font-size-09rem">
                                                    {item.biography}
                                                    </p>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs="12" md="6">
                                            <ItemsHourExternal 
                                                doctorId={item.doctor.id}
                                                onClickSelectedSchedule={onClickSelectedSchedule}
                                                onClickShowCitaPatient={onClickShowCitaPatient} 
                                                account={account}
                                                company={company}
                                                currentPage={currentPage}
                                                linkAllianz={linkAllianz}
                                                isSort={isSort}
                                                setIsSort={setIsSort}
                                                ordering={ordering}
                                                setCheckIndex={setCheckIndex}
                                                setBasicItems={setBasicItems}
                                                basicItems={basicItems}
                                                doctorRef={doctorRef}
                                                setCountDr={setCountDr}
                                                countDr={countDr}
                                            />
                                        </Col>
                                    </Row>
                                    
                                </Card.Body>
                            </Card>
                        </Col>
                    ))
                }
            </Row>
            {items.length > 0 && <Row className="mt-5">
                <Col>
                    <ReactPaginate
                        previousLabel={<RiArrowLeftSLine />}
                        nextLabel={<RiArrowRightSLine />}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                    />
                </Col>
            </Row>}
        </>
        
    )
}

export default withTranslation()(ItemsDoctors)